// Navbar.js

import React from "react";
import './navbar.css';
import { useNavigate } from "react-router-dom";


const Navbar = () => {

  const navigate = useNavigate();
  const handleClick = (path) => {
    navigate(path);
};

  return (
    <header className="navbar">
      <div className="header-buttons">
        <button type='button' className="button-common" onClick={()=> handleClick('/')}>
          Home
        </button>
        <button type='button' className="button-common" onClick={()=> handleClick('/Profile')}>
          Profile
        </button>
        <button type='button' className="button-common" onClick={()=> handleClick('/Contact')}>
          Contact
        </button>
      </div>
    </header>
  );
}

export default Navbar;
